import React from 'react';
import Dropdown from '@grnhse/seedling/lib/azalea/components/dropdown_select';
import type { Props } from '@grnhse/seedling/lib/azalea/components/dropdown_select/types';
import t from 'shared/utils/translation';

const noOptionsMessage = () => t('select.noResultsText');
const loadingMessage = () => t('select.loadingMessage');

const withSelectTranslations =
  (DropdownComponent: (props: Props) => React.ReactElement<any>) =>
  (props: Props) => {
    return (
      <DropdownComponent
        placeholder={t('select.placeholder')}
        noOptionsMessage={noOptionsMessage}
        loadingMessage={loadingMessage}
        {...props}
      />
    );
  };

const TranslatedDropdown = withSelectTranslations(Dropdown);
export default TranslatedDropdown;
